document.addEventListener('click', function (e) {
  var btn = e.target.closest('[data-cart-shipping-add]');
  if (!btn || btn.disabled) return;
  e.preventDefault();
  btn.disabled = true;
  var originalText = btn.textContent;
  btn.textContent = 'Adding...';
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ items: [{ id: parseInt(btn.dataset.variantId, 10), quantity: 1 }] })
  })
    .then(function (r) { return r.json(); })
    .then(function () {
      document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { data: {} } }));
    })
    .catch(function () {
      btn.disabled = false;
      btn.textContent = originalText;
    });
});
